@use '../../styles/variables' as *;

.inputFormWrap {
  max-width: 430px;
  margin-left: auto;
  background-color: rgba(220, 217, 210, 0.44);
  padding: 40px 50px;
  padding-bottom: 20px;
  border-radius: $borderRadius;
  @media screen and (max-width: 600px) {
    padding: 30px;
  }
  h3,
  h5 {
    margin-top: 0;
  }
}
.formGroup {
  margin-bottom: 15px;

  label {
    display: block;
    font-size: $smallTextSize;
    color: $textBlack;
    margin-top: 5px;
    font-weight: bold;
    padding-bottom: 5px;
    font-weight: 400;
  }
  input {
    height: 50px;
    font-family: inherit;
    width: 100%;
    box-sizing: border-box;
    border-radius: 4px;
    border: 2px solid $textBlack;
    padding: 0 10px;
    line-height: 100%;
    font-size: $inputTextSize;
    color: $textBlack;
    outline: none;
    transition: all 0.3s;
    &:focus {
      border-color: $lightGreen;
    }
  }
}
